import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import { loadSpecification } from "src/business/specification";
import {
  loadValueCatalog,
  valueCatalogCardsLoader,
} from "src/business/valueCatalog/apiValueCatalog";
import { ValueCatalogCardsFilter } from "src/business/valueCatalog/ValueCatalogFilter";
import { ZValueCatalog } from "src/business/valueCatalog/ZValueCatalog";
import { ZValueCatalogCardSafe } from "src/business/valueCatalog/ZValueCatalogCard";
import { RemoteData } from "src/common/RemoteData";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { PageUrl } from "src/routes/PageUrl";

import { buildValueCatalogColumns } from "../../../../../business/valueCatalog/buildValueCatalogColumns";

export type ValueCatalogData = {
  catalog: ZValueCatalog;
  table: RtStore<ZValueCatalogCardSafe, ValueCatalogCardsFilter>;
  columns: RtColumn<ZValueCatalogCardSafe>[];
};

export const valueCatalogContentStore = makeAutoObservable({
  async init(id: string) {
    try {
      this.setData({ status: "wait" });
      const catalog = await loadValueCatalog(id);
      const spec = await loadSpecification("values", catalog.schema.id);
      const columns = buildValueCatalogColumns(spec);
      const table = new RtStore<ZValueCatalogCardSafe, ValueCatalogCardsFilter>(
        {
          rowKey: "id",
          loader: valueCatalogCardsLoader(id, spec),
          defaultRequest: { pageSize: 20 },
        },
      );
      const result = { catalog, columns, table };
      this.setData({ status: "ready", result });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  data: { status: "none" } as RemoteData<ValueCatalogData>,
  setData(newData: RemoteData<ValueCatalogData>) {
    this.data = newData;
  },
  get title(): BreadcrumbItem[] {
    const list: BreadcrumbItem[] = [
      { title: "Каталоги значений", page: PageUrl.managementValueCatalogs },
    ];
    const { data } = this;
    if (data.status === "ready") {
      list.push({ title: data.result.catalog.name });
    }
    return list;
  },
});
